import React, { useContext } from 'react'
import zeroState from '../../../Assets/Images/folder-search.png'
import LanguageContext from '../../../Store/LanguageContext'
import ModalContext from '../../../Store/ModalContext'
import MultipleAssessmentsContext from '../../../Store/MultipleAssessmentsContext'
import { translate } from '../../translate/translate'

const ZeroState = ({ route }) => {
  const langCtx = useContext(LanguageContext)
  const modalCtx = useContext(ModalContext)
  const multipleAssessmentsCtx = useContext(MultipleAssessmentsContext)

  const handleTranslate = (text, type) => {
    switch (langCtx.language) {
      case "Nederlands": {
        return translate(text, "dashboardCompareDutch", type)
      }
      default: {
        return text;
      }
    }
  }

  const getRouteMessage = () => {
    if (route === "Overview") {
      return handleTranslate("Overview isn't available yet", "overview-not-available")
    } else if (route === "Comparison") {
      return handleTranslate("Comparison isn't available yet", "comparison-not-available")
    } else {
      return `${route} isn't available yet.`
    }
  }

  const handleOpenCreateAssessmentModal = () => {
    modalCtx.openModal('createAssessment', { hashId: multipleAssessmentsCtx.currentAssessmentId }
    )
  }

  return (
    <div className='box-zero-state'>
      <div className='box-container'>
        <img src={zeroState} alt="zero state" />
        <h1>{getRouteMessage()}</h1>
        <p>{handleTranslate("Once you launch another assessment, you'll see side-by-side insights here.", "side-by-side-insights")}</p>
        <button onClick={handleOpenCreateAssessmentModal}>
          {handleTranslate("Create New Assessment", "create-new-assessment")}
        </button>
      </div>
    </div>
  )
}

export default ZeroState